"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeUserValidationSchema = makeUserValidationSchema;
const Yup = __importStar(require("yup"));
const accountFieldsValidation_1 = require("../../../Persons/accountFieldsValidation");
const PersonValidationSchema_1 = require("../../../Persons/Modals/PersonValidationSchema");
/**
 * Reguły modalu dodawania użytkownika: pola osoby + pola konta.
 *
 * Obie połowy są importowane, nie przepisane: pola osoby sprawdza tak samo okno „Osoby",
 * a pola konta - ta sama trasa `PUT /v2/persons/:id/account`, którą zapisuje modal
 * uprawnień. Komunikat przy tym samym polu ma brzmieć wszędzie identycznie.
 */
function makeUserValidationSchema(isEditing) {
    return Yup.object().shape({
        ...PersonValidationSchema_1.personFields,
        // Rola jest wymagana już przy zakładaniu: konto bez roli logowałoby się
        // jako EXTERNAL_USER (wartość domyślna bazy), czego nikt nie wybrał.
        // Transform, bo pusty wybór w selektorze dojeżdża jako "" - bez niego yup
        // rzuciłby błędem typu zamiast czytelnym „Wybierz rolę systemową".
        systemRoleId: Yup.number()
            .required("Wybierz rolę systemową")
            .transform((value, original) => (original === "" || original === null ? undefined : value)),
        ...accountFieldsValidation_1.accountFields,
    });
}
